import { InventoryController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { inventoryStore, userStore } from '../../stores';
import constant from '../../utils/constant';
import { EditStock } from '../../pages';
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const EditStockContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [varyType, setVaryType] = useState(false)

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.STOCKEDITSTOCK);

	useEffect(() => {
		if (inventoryStore?.selectedStock?.product?.type === "Product") {
			setVaryType(true)
		}
	}, [])

	const selectedStock = inventoryStore.selectedStock;

	const validationSchema = (validCondition) => {
		return yup.object({
			title: yup.string().required('title is required'),
			// quantity: yup.number()
			// 	.when('validCondition', {
			// 		is: true,
			// 		then: (schema) => schema.min(0.1, 'Minimum should be 0.1').required('quantity is required'),
			// 		otherwise: (schema) => schema.optional()
			// 	}),
			sellingPrice: yup
				.number()
				.min(1, 'Minimum should be 1')
				.required('Selling Price is required'),
			// costPrice: yup
			// 	.number()
			// 	.min(0, 'Minimum should be 1')
			// 	.required('Cost Price is required'),
			currencyCode: yup.string().required('Select Currency'),
			// variations: yup.array(
			// 	yup.object({
			// 		type: yup.string().required('Type is required'),
			// 		value: !validCondition ? yup.string().required('Value is required') : yup.string(),
			// 	})
			// ),
		});
	};
	const onSubmit = async payload => {
		setLoading(true);
		if (inventoryStore?.selectedStock?.product?.type === "Service") {
			payload.quantity = 100000
		}
		if (payload.variations.length === 1 && payload.variations[0].value === "" && payload.variations[0].type === "") {
			payload.variations = []
		}
		delete payload.validCondition;
		delete payload.hasImages;
		delete payload.hasMulticurrency;
		delete payload.quantity;
		delete payload.sellingPriceUSD;
		delete payload.sellingPriceGBP;
		delete payload.sellingPriceEUR;
		delete payload.sellingPriceNGN;

		const { status, errorMessage } = await InventoryController.updateStocks(
			payload,
			inventoryStore.selectedStock?._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			inventoryStore.setSelectedStock({});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const onSelect = async (values) => {
		const amount = values.sellingPriceUSD;
		await InventoryController.getRates('USD', amount);
	};

	return (
		<EditStock
			closeModal={closeModal}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			varyType={varyType}
			setVaryType={setVaryType}
			selectedStock={selectedStock}
			onSelect={onSelect}
		/>
	);
};

export default observer(EditStockContainer);
